import { render, staticRenderFns } from "./LoansOngoing.vue?vue&type=template&id=13215192&"
import script from "./LoansOngoing.vue?vue&type=script&lang=js&"
export * from "./LoansOngoing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports